import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export const RedirectToGoals = () => {
  const location = useLocation();

  return (
    <Navigate
      to={{
        pathname: "/apps/goals",
        search: location.search,
      }}
      replace
    />
  );
};
